import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from '../components/ui/sonner';
import { Logo } from '../components/Logo';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { ADMIN_LOGIN } from '../constants/testIds';
import { getErrorMessage } from '../lib/errors';
import { setAdminToken } from '../lib/authTokens';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { email, password }, { withCredentials: true });
      if (data.access_token) setAdminToken(data.access_token);
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error(getErrorMessage(err, 'Invalid email or password'));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-bg text-brand-text flex items-center justify-center px-5">
      <div className="text-center max-w-sm w-full">
        <div className="flex justify-center mb-8">
          <Logo />
        </div>
        <h1 className="font-display font-extrabold uppercase text-2xl text-brand-text">Admin Login</h1>
        <p className="mt-2 text-brand-muted text-sm">Sign in to view bulk orders &amp; website leads.</p>

        <form onSubmit={handleSubmit} className="mt-8 space-y-4 text-left">
          <div>
            <Label className="text-brand-muted text-xs uppercase tracking-wider">Email</Label>
            <Input
              type="email"
              required
              data-testid={ADMIN_LOGIN.emailInput}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1.5 bg-brand-surface2 border-brand-border text-brand-text"
            />
          </div>
          <div>
            <Label className="text-brand-muted text-xs uppercase tracking-wider">Password</Label>
            <Input
              type="password"
              required
              data-testid={ADMIN_LOGIN.passwordInput}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1.5 bg-brand-surface2 border-brand-border text-brand-text"
            />
          </div>
          <button
            type="submit"
            disabled={submitting}
            data-testid={ADMIN_LOGIN.submitButton}
            className="w-full inline-flex items-center justify-center gap-2 bg-brand-orange hover:bg-brand-orangeHover text-white font-display font-bold uppercase tracking-wide rounded-full px-7 py-3 transition-colors disabled:opacity-60"
          >
            {submitting ? 'Signing in…' : 'Log In'}
          </button>
        </form>
      </div>
    </div>
  );
}
